//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import React from "react";
import { InstantSearch } from "react-instantsearch";
import TypesenseAdapter from "typesense-instantsearch-adapter";
import { ActualSearchButton, SearchLikeButton } from "../navbar/components";
import { useSearchBox, useHits } from "react-instantsearch";
import { useLocalStorage } from "../../../tutor-application/utils";
import { SearchComponent as SearchButtonWithHook } from "./SearchButtonWithHook";

type SearchResultType = {
  name: string;
  description: string;
  url: string;
  keywords: string[];
  popular: string;
};
export const useTypesenseHook = (goToSearch: (str: string) => void) => {
  const { refine, query } = useSearchBox();
  const { value, setValue, removeValue } = useLocalStorage("site-search", []);
  const { hits } = useHits();
  function buildIndices(result: any) {
    return {
      text: result.name,
      indices: [],
      paths: [result.description],
      href: result.url,
    };
  }
  const onSaveSearch = (searchTerm: string, url?: string) => {
    const find = (value || [])
      .map((r) => r.toLowerCase())
      .find((item) => item.startsWith(searchTerm.toLowerCase()));
    if (!find) {
      setValue([...(value || []), searchTerm]);
    }
    if (url) {
      if (goToSearch) {
        console.log("url", url);
        goToSearch(url);
      }
    }
  };
  let previousSearches = [];
  if (value?.length > 0) {
    previousSearches = value.map((searchTerm: string) => {
      return {
        search: searchTerm,
        textOnly: true,
        location: {
          paths: [],
          url: "",
        },
      };
    });
  }
  const popularSearches = (hits as SearchResultType[])
    .filter((r) => r.popular === "true")
    .map((hit) => {
      return {
        search: hit.name,
        location: {
          paths: [hit.description],
          url: hit.url,
        },
      };
    });
  const onClearHistory = () => {
    console.log("clearing history");
    removeValue();
    refine("");
  };
  const searchHistories = [];
  if (previousSearches.length > 0) {
    searchHistories.push({
      heading: "Recent searches",
      items: previousSearches,
      onClear: onClearHistory,
    });
  }
  if (popularSearches.length > 0) {
    searchHistories.push({
      heading: "Popular searches",
      items: popularSearches,
    });
  }
  async function onSearch(searchTerm: string) {
    refine(searchTerm);
    return Promise.resolve(hits.map(buildIndices));
  }
  return {
    onSearch,
    searchHistories,
    onSaveSearch,
  };
};

const searchAdapter = new TypesenseAdapter({
  server: {
    apiKey: "7u7EUGkErLino4Rk",
    nodes: [
      {
        host: "typesense.tuteria.com",
        port: 443,
        protocol: "https",
      },
    ],
  },
  additionalSearchParameters: {
    query_by: "name,keywords,description",
    query_by_weights: "4,2,1",
  },
});
type SearchComponentProps = {
  placeholder?: React.ReactNode;
  loaded?: boolean;
  goToSearch: (str: string) => void;
};
const SearchComponent = ({
  placeholder,
  goToSearch,
  loaded,
}: SearchComponentProps) => {
  const component = (r) => {
    return (
      <>
        <ActualSearchButton onClick={r.onOpen}>
          {placeholder}
        </ActualSearchButton>
        {loaded && (
          <InstantSearch
            indexName="site_wide"
            searchClient={searchAdapter.searchClient}
          >
            <SearchButtonWithHook
              modalControl={r}
              goToSearch={goToSearch}
              path={"/search-path"}
            >
              {placeholder}
            </SearchButtonWithHook>
          </InstantSearch>
        )}
      </>
    );
  };
  return <SearchLikeButton loaded={loaded} render={component} />;
};

export const SearchClient = ({
  children,
  onSearch,
  loaded,
}: {
  children?: React.ReactNode;
  onSearch: (str: string) => void;
  loaded?: boolean;
}) => {
  return (
    <SearchComponent
      loaded={loaded}
      placeholder={children}
      goToSearch={onSearch}
    />
  );
};

export default SearchClient;
